export const ORGANIZATION_UNAUTHORIZED = 4010001;
export const IP_RANGE_INVALID = 4010002;

export const GENERIC_SERVER_ERROR_MESSAGE =
  'Something went wrong, please try again in a few seconds';
